export default [
    {
        header: 'Rapport',
        module: 'report',
        profile: ['Admin','AdminSuper','Technician']
    },
    {
        title: 'Rapport Objectifs',
        route: 'objectif-repport',
        icon: 'ListIcon',
        module: 'report',
        profile: ['Admin','AdminSuper','Technician'],
   },
    {
        title: 'Rapport Evaluation',
        route: 'evaluation-repport',
        icon: 'CheckSquareIcon',
        module: 'report',
        profile: ['Admin','AdminSuper','Technician']
    }

]